import React from "react";
import ResponsiveGestionAchat from "../gestion-achat/ResponsiveGestionAchat";

const GestionBonCommande: React.FC = () => {
  return (
    <ResponsiveGestionAchat
      orderType="purchase_order"
      moduleLabel="bon de commande"
      moduleLabelPlural="bons de commande"
    />
  );
};

export default GestionBonCommande;
